<template>
  <v-form v-if="uh" id="identify-visitor">
    <v-overlay v-if="directFinish" absolute></v-overlay>
    <v-app-bar app color="primary" dark>
      <v-btn dark icon @click="$router.push({ name: 'categories' })">
        <v-icon dense x-large>mdi-chevron-left</v-icon>
      </v-btn>

      <v-toolbar-title class="pl-5">Identifique-se</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
          icon
          @click="
          $router.push({
            name: 'cart',
            query: { unix: Date.now().toString() },
          })
        "
      >
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </v-app-bar>
    <v-flex xs12 sm12 md12 lg12>
      <v-card-actions>
        <v-card-text>Escaneie o QR Code do seu Cartão Consumo</v-card-text>
        <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
      </v-card-actions>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12 class="scanner">
      <qrcode-stream @decode="onDecode"></qrcode-stream>
    </v-flex>
    <active-card v-on:activeCard="activeCard" ref="active-card"></active-card>
  </v-form>
  <v-overlay v-else absolute color="white"
             opacity="0.85">
    <v-layout column style="width: 45vw">
      <v-flex class="text-center">
        <v-icon color="primary" size="30">send</v-icon>
      </v-flex>
      <v-flex class="text-center">
          <span
              class="body-2 font-weight-light text--primary"
              style="user-select: none"
          >Enviando pedido...</span
          >
      </v-flex>
    </v-layout>
  </v-overlay>
</template>

<script>
import OrderService from "../services/orderService";
import VisitService from "../services/visitService";

import ActiveCard from "./ActivateCard";

export default {
  name: "identify-visitor",
  components: {"active-card": ActiveCard},
  data() {
    return {
      code: "",
      consumptionCard: {
        id: 0,
        number: "",
      },
      room: null,
      directFinish: true,
      uh:false
    };
  },
  async mounted() {
    if (localStorage.getItem("accessPoint") != null) {
      const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
      if (accessPoint.type === "TABLE") {
        localStorage.setItem(
            "consumptionCard",
            accessPoint.consumption_card.number
        );
        localStorage.setItem("visit", accessPoint.visit_id);
      }
      if (accessPoint.type === "UH") {
        await this.finish();
      }
    }
    if (
        localStorage.getItem("consumptionCard") != null &&
        localStorage.getItem("consumptionCard") !== ""
    ) {
      await this.finish();
    }
    this.directFinish = false;
  },
  methods: {
    async onDecode(decodedString) {
      this.code = decodedString;

      try {
        const responseHitsRooms = await new VisitService().getHitsRooms();
        let finished = false;
        responseHitsRooms.data.forEach((room) => {
          if (!finished) {
            if (room.identificationCard === this.code) {
              finished = true;
              this.room = room;
              this.finish();
            }
          }
        });
      } catch (e) {
        console.error(e);
      }

      if (this.room == null) {
        const response = await new OrderService().getConsumptionCard(this.code);
        this.consumptionCard = response.data;

        if (localStorage.getItem("consumptionCard") != null) {
          if (
              localStorage.getItem("consumptionCard").toString() !==
              decodedString &&
              this.consumptionCard.status === "ACTIVE"
          ) {
            this.$info(
                "",
                "Já foi associado um cartão de consumo diferente à sua conta!",
                "error"
            );
            return;
          }
          this.finish();
          return;
        }

        this.$refs["active-card"].handleOpen(this.consumptionCard);
      }
    },
    activeCard() {
      this.finish();
    },
    async finish() {
      let accessPoint = null;
      if (localStorage.getItem("accessPoint") != null)
        accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
      const cart = JSON.parse(localStorage.getItem("cart"));
      let pdvs = [];
      cart.products.forEach((product) => {
        let add = true;
        pdvs.forEach((p) => {
          if (p.id === product.pdv.id) add = false;
        });
        if (add) pdvs.push(product.pdv);
      });

      let visitId = 0;
      if (localStorage.getItem("visit") != null) {
        visitId = localStorage.getItem("visit");
      }

      this.code = localStorage.getItem("consumptionCard");
      if (this.code) {
        const response = await new OrderService().getConsumptionCard(this.code);
        this.consumptionCard = response.data;
      }

      const orders = [];
      pdvs.forEach((pdv) => {
        const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
        const order = {
          access_point_id: accessPoint.id,
          pdv_id: parseInt(pdv.id, 10),
          visit_id: parseInt(visitId),
          visit: {
            access_point_id: accessPoint.id,
            id: parseInt(visitId),
            card_id: this.consumptionCard.id,
            card: this.consumptionCard,
            consumption_card: this.consumptionCard.number,
          },
          entries: [],
        };
        if (accessPoint.type === "UH") {
          if (!order.data || !order.data.length) order.data = [];
          let room = JSON.parse(localStorage.getItem("room"));
          if (room) {
            this.room = room
          } else {
            order.data.push({
              key: "app_sistemas_room_id",
              value: accessPoint.number + "",
            });
          }
        }
        if (this.room != null) {
          if (!order.data || !order.data.length) order.data = [];
          order.data.push({
            key: "app_sistemas_room_id",
            value: this.room.global + "",
          });
          order.data.push({
            key: "app_sistemas_room_number",
            value: this.room.room + "",
          });
          order.data.push({
            key: "app_sistemas_room_name",
            value: this.room.name + "",
          });
          if (this.room.federalRegistrationNumber) {
            order.data.push({
              key: "app_sistemas_room_document",
              value: this.room.federalRegistrationNumber + "",
            });
          }
          order.data.push({
            key: "app_sistemas_room_card",
            value: this.room.identificationCard + "",
          });
        }
        const products = cart.products.filter(
            (product) => product.pdv.id === pdv.id
        );
        products.forEach((product) => {
          let entry = order.entries.filter(
              (e) => e.product_id || e.product_combo_id === product.id
          )[0];
          if (entry == null) {
            entry = {
              product_id: product.products ? 0 : parseInt(product.id, 10),
              product_combo_id:  product.products ? product.id: 0,
              options: [],
              entries: product.products ? this.generateEntries(product) : [],
            };
            this.addEntryOptions(entry, product);
            entry.amount = product.amount;
            order.entries.push(entry);
          } else {
            entry.amount =
                parseInt(entry.amount, 10) + parseInt(product.amount, 10);
            this.addEntryOptions(entry, product);
          }
        });
        orders.push(order);
        // try {
        //   const newOrder = await new OrderService().finishOrder(order);
        //   cart.products = cart.products.filter(
        //     product => product.pdv.id !== order.pdv_id
        //   );
        //   successOrders.push(newOrder);
        //   successPDVs.push(pdv.name);
        // } catch {
        //   errorPDVs.push(pdv.name);
        // }
      });
      try {
        const createdOrders = [];
        if (accessPoint.type === "UH" || this.room != null) {
          const res = await new OrderService().finishOrderHits(orders[0]);
          createdOrders.push(res.data);
        } else {
          const res = await new OrderService().finishOrders(
              localStorage.getItem("consumptionCard"),
              orders
          );
          res.data = res.data || [];
          res.data.forEach((e) => {
            createdOrders.push(e.id);
          });
        }

        this.$nextTick(() => {
          localStorage.removeItem("cart");
          this.$router.push({
            name: "cart",
            query: {unix: Date.now().toString()},
          });
          this.$info(`Pedido realizado!`);
        });
      } catch (e) {
        if (!this.directFinish) {
          this.$info("Erro ao Realizar Pedido!", e.message, "error");
        } else if (
            e.message.indexOf("visita está encerrada") != -1 ||
            e.message.indexOf("não possui uma visita ativa") != -1
        ) {
          localStorage.removeItem("visit");
          localStorage.removeItem("consumptionCard");
          this.$info("Erro ao Realizar Pedido!", e.message, "error");
        } else {
          this.$info("Erro ao Realizar Pedido!", e.message, "error");
        }
      }

      this.$destroy();
      this.$router.push({
        name: "cart",
        query: {unix: Date.now().toString()},
      });
    },
    addEntryOptions(entry, product) {
      if (product.products)return;
      let index = entry.amount != null ? parseInt(entry.amount, 10) : 0;
      for (let i = 0; i < product.amount; i++) {
        const option = {
          index: index + i,
          memo: product.memo,
          accompaniments: [],
          additionals: [],
          optionals: [],
        };
        product.accompaniments.forEach((accompaniment) => {
          option.accompaniments.push({
            item_id: parseInt(accompaniment.id, 10),
          });
        });
        product.additionals.forEach((additional) => {
          option.additionals.push({item_id: parseInt(additional.id, 10)});
        });
        product.optionals.forEach((optional) => {
          option.optionals.push({item_id: parseInt(optional.id, 10)});
        });
        entry.options.push(option);
      }
    },generateEntries(product) {
      let entries =  [];
      product.products.forEach( pro =>{
        let productCombo = {
          product_id:pro.product.id,
          amount: 1,
          options: []
        }
        let options = {
          accompaniments :[],
          additionals:[],
          optionals:[],
          memo:pro.product.memo
        }
        if (pro.product.product_accompaniments)
          pro.product.product_accompaniments.forEach(additional => {
            console.log(additional)
            additional.accompaniment_category.accompaniments.forEach(a =>{
              if(a.active)options.accompaniments.push({
                item_id: a.id,
                option_id: a.option_id,
              })
            })
          });
        if (pro.product.product_additionals)
          pro.product.product_additionals.forEach(additional => {
            additional.additional_category.additionals.forEach(a =>{
              if(a.active)options.additionals.push({
                item_id: a.id,
                option_id: a.option_id,
              })
            })
          });
        if (pro.product.product_optionals)
          pro.product.product_optionals.forEach(additional => {
            additional.optional_category.optionals.forEach(a =>{
              if(a.active)options.optionals.push({
                item_id: a.id,
                option_id: a.option_id,
              })
            })
          });
        productCombo.options.push(options)
        entries.push(productCombo);
      })
      return entries;
    }
  },
};
</script>

<style>
.scanner {
  background: white;
  position: relative;
  width: 300px;
  height: 300px;
  margin: 3em auto;
  border: solid 10px #37713b;
}

.scanner::before,
.scanner::after {
  position: absolute;
  background: inherit;
  content: "";
  z-index: 1;
}

.scanner::before {
  width: 150px;
  left: calc(50% - 75px);
  height: calc(100% + 28px);
  top: -14px;
}

.scanner::after {
  height: 150px;
  left: -14px;
  width: calc(100% + 28px);
  top: calc(50% - 75px);
}

.scanner > * {
  position: relative;
  z-index: 2;
}

.scanner .wrapper {
  z-index: 3 !important;
}

#identify-visitor .v-overlay__scrim {
  opacity: 1 !important;
}
</style>
